export default __webpack_public_path__ + "static/media/services03.dc91bbf8.jpg";